<script setup>
import { ref } from 'vue'
import { useMainStore } from '@/stores/main'
import { useI18n } from 'vue-i18n'
import * as Alerts from '@/services/Alerts'
import * as Server from '@/services/Server'

const store = useMainStore()
const group = defineModel()
const { t } = useI18n()

const loading = ref(false)
const showDialog = ref(false)

const openDialog = () => {
  showDialog.value = true
}

const recalculate = async () => {
  
  loading.value = true
  try {
    const path = store.apiPath.recalculate_standings.replace('{group}', group.value.id)
    const response = await Server.post(path)
    group.value.group_entries = response.data
    Alerts.success(t('message.standingsRecalculatedSuccess'))

  } catch (error) {
    console.error('Error recalculating standings:', error)
    const message = error.response?.data?.message || 'An error occurred'
    Alerts.error(message)
  } finally {
    loading.value = false
  }

  showDialog.value = false
}

</script>

<template>
  
  <v-btn 
    color="primary" 
    variant="outlined"
    prepend-icon="mdi-refresh"
    @click="openDialog"
  >
    {{ $t('label.recalculateStandings') }}
  </v-btn>

  <v-dialog v-model="showDialog" class="common-dialog">
    <v-card>
      <v-card-title class="text-h5">
        {{ $t('label.recalculateStandings') }}
      </v-card-title>

      <v-divider />

      <v-card-text>
        {{ $t('message.recalculateStandingsInfo') }}
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-btn
          color="primary"
          variant="elevated"
          prepend-icon="mdi-refresh"
          @click="recalculate"
        >
          {{ $t('common.confirm') }}
        </v-btn>
        <v-spacer />
        <v-btn
          color="grey"
          variant="text"
          @click="showDialog = false"
        >
          {{ $t('button.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>
